module.exports = __webpack_public_path__ + "img/stub.92308605.png";